module.exports = __webpack_public_path__ + "img/process.93f42aa1.png";